import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import EngineeringIcon from '@mui/icons-material/Engineering';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getpurchase } from '../redux/purchase';
import Progress from '../components/Loader';

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [loading, setLoading] = React.useState(false);
  const [customer, setCustomer] = React.useState('none');
  const [productservice, setProductService] = React.useState('none');
  const [unit, setUnit] = React.useState('none');
  const [method, setMethod] = React.useState('none');
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();
  const customerData = useSelector((state) => state.agent || []);
  const product = useSelector((state) => state.product || []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };
  const handleSnackbarClose = () => setSnackbarOpen(false);

  const clearForm = () => {
    setCustomer('none');
    setProductService('none');
    setUnit('none');
    setMethod('none');
    document.getElementById('quantity').value = '';
    document.getElementById('amount').value = '';
    document.getElementById('others').value = '';
  };

  const receiveGoods = async () => {
    setLoading(true);
    const received = props.chosen.qtyreceived ? parseFloat(props.chosen.qtyreceived) : 0;
    const total = received + parseFloat(document.getElementById('quantity').value || 0);

    try {
      const res = await axios.post('https://server.agrotraciserp.com/api/purchase/editpurchase/', {
        price: document.getElementById('amount').value,
        qtyreceived: total,
        unit: unit,
        status: 'Received',
        id: props.chosen.id,
        customer: customer,
        paymentmethod: method,
        product: productservice,
        others: document.getElementById('others').value,
      });

      if (res.status === 200) {
        setLoading(false);
        dispatch(getpurchase({ data: res.data }));
        setSnackbarMessage('Goods received successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to receive goods.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error receiving goods.');
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Receive New Goods
      </Button>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Receive New Goods
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Customer / Farmer"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              {customerData.map((list) => (
                <option key={list.principal} value={list._id}>
                  {list.othername+" "+list.lastname}
                </option>
              ))}
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Product"
              value={productservice}
              onChange={(e) => setProductService(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Onion">Onion</option>
              <option value="Tomatoes">Tomatoes</option>
              <option value="Pepper">Pepper</option>
              <option value="Maize">Maize</option>
              <option value="Soybean">Soybean</option>
              <option value="Other">Other</option>
             
            </TextField>
            <TextField id="quantity" label="Quantity" type="text" autoComplete="current-text" />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Measuring Unit"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Kg">Kg</option>
              <option value="Tons">Tons</option>
              <option value="bags">bags</option>
            </TextField>
            <TextField
              id="amount"
              label="Price"
              type="number"
              autoComplete="current-text"
              InputProps={{
                startAdornment: <InputAdornment position="start">GHC</InputAdornment>,
              }}
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Payment Method"
              value={method}
              onChange={(e) => setMethod(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Cash">Cash</option>
              <option value="Cheque">Cheque</option>
              <option value="Credit">Credit</option>
            </TextField>
            <TextField id="others" label="Other Descriptions" multiline rows={4} />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<EngineeringIcon />} size="large" onClick={receiveGoods}>
                Receive Goods
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}